export const ROLE = {
  ROLE_USER: {
    value: '사용자',
    key: 'ROLE_USER'
  },
  ROLE_ADMIN: {
    value: '관리자',
    key: 'ROLE_ADMIN'
  },
  ROLE_SUPER: {
    value: '슈퍼관리자',
    key: 'ROLE_SUPER'
  }
};
export const JOIN_TYPE = {
  GENERAL: {
    value: '일반',
    key: 'GENERAL'
  },
  APPLE: {
    value: '애플',
    key: 'APPLE'
  },
  GOOGLE: {
    value: '구글',
    key: 'GOOGLE'
  },
  KAKAO: {
    value: '카카오',
    key: 'KAKAO'
  },
  NAVER: {
    value: '네이버',
    key: 'NAVER'
  },
  FACEBOOK: {
    value: '페이스북',
    key: 'FACEBOOK'
  }
};
export const USER_STATUS = {
  ACTIVE: {
    value: '활성',
    key: 'ACTIVE'
  },
  SLEEP: {
    value: '휴면',
    key: 'SLEEP'
  },
  WITHDRAW: {
    value: '탈퇴',
    key: 'WITHDRAW'
  },
  READY: {
    value: '대기',
    key: 'READY'
  },
  BLOCK: {
    value: '정지',
    key: 'BLOCK'
  },
  DELETE: {
    value: '삭제',
    key: 'DELETE'
  }
};
export const USER_STATUS_TYPE = [
  {
    value: 'ACTIVE',
    label: '일반'
  },
  {
    value: 'WITHDRAW',
    label: '탈퇴'
  },
];
export const DEVICE_TYPE = {
  ANDROID: {
    value: 'ANDROID',
    key: 'ANDROID'
  },
  IOS: {
    value: 'IOS',
    key: 'IOS'
  }
};